import { create } from 'zustand';
import { authApi, type User } from '@/lib/api/endpoints';
import { tokenStore } from '@/lib/api/client';

interface AuthState {
  user: User | null;
  loading: boolean;
  initialized: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, fullName?: string, inviteCode?: string) => Promise<void>;
  logout: () => Promise<void>;
  loadCurrentUser: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: false,
  initialized: false,
  async login(email, password) {
    set({ loading: true });
    try {
      const { user } = await authApi.login({ email, password });
      set({ user, loading: false, initialized: true });
    } catch (err) { set({ loading: false }); throw err; }
  },
  async register(email, password, fullName, inviteCode) {
    set({ loading: true });
    try {
      await authApi.register({ email, password, fullName, inviteCode });
      await authApi.login({ email, password });
      const { user } = await authApi.me();
      set({ user, loading: false, initialized: true });
    } catch (err) { set({ loading: false }); throw err; }
  },
  async logout() {
    await authApi.logout();
    set({ user: null });
  },
  async loadCurrentUser() {
    if (!tokenStore.getAccess()) {
      set({ initialized: true });
      return;
    }
    try {
      const { user } = await authApi.me();
      set({ user, initialized: true });
    } catch {
      tokenStore.clear();
      set({ user: null, initialized: true });
    }
  },
}));
